import React, { Component } from 'react';
import { Spin } from 'antd';
// import Head from 'next/head';
import { Helmet } from 'react-helmet';

import * as structured from '../structured';
import Header from '../components/Header';
import OldHeader from '../components/OldHeader';
import Footer from '../components/Footer';
import PeopleSection from '../components/PeopleSection';
import BannerSection from '../components/BannerSection';
import VideoSection from '../components/VideoSection';
import TopInfoSection from '../components/TopInfoSection';
import UnverifiedSection from '../components/UnverifiedSection';
import ContactSection from '../components/ContactSection';
import PracticeInfoSection from '../components/PracticeInfoSection';
import BenefitsSection from '../components/BenefitsSection';
import PricingSection from '../components/PricingSection';
import MapperSection from '../components/MapperSection';
import LocationPhotosSection from '../components/LocationPhotosSection';
import SendMessageSection from '../components/SendMessageSection';
import EnrollmentSection from '../components/EnrollmentSection';
import DPCSection from '../components/DPCSection';

import * as globals from '../globals';

// import '../style/PracticePage.scss';

class PracticePage extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, data: null };
  }

  // static async getInitialProps({ res, query }) {
  //   if (process.browser) return {};
  //   console.log(JSON.stringify(query, null, 2));
  //   const pid = query.pid;
  //   console.log('pid');
  //   console.log(JSON.stringify(pid, null, 2));
  //   if (!pid) {
  //     res.writeHead(302, { Location: '/404' });
  //     res.end();
  //     return {};
  //   }

  //   const snap = await globals.db
  //     .child(`practices`)
  //     .orderByChild('id')
  //     .equalTo(pid)
  //     .once('value');
  //   if (!snap || !snap.exists() || Object.keys(snap.val()).length === 0) {
  //     res.writeHead(302, { Location: '/404' });
  //     res.end();
  //     return {};
  //   }

  //   let result = snap.val();
  //   // console.log(JSON.stringify(result, null, 2));
  //   let pracKeys = Object.keys(result);
  //   if (!pracKeys.length) {
  //     res.writeHead(302, { Location: '/404' });
  //     return;
  //   }
  //   let pracKey = pracKeys[0];
  //   let practiceData = result[pracKey];
  //   return { data: practiceData, pracKey, pid: pid };
  // }

  componentDidMount = () => {
    console.log('Mounted practice page');
    console.log(this.props);
    console.log('Match props');
    console.log(JSON.stringify(this.props.match, null, 2));
    let pid = this.props.pid || this.props.match.params.pid;
    console.log('Got pid: ' + pid);

    this.unsub = globals.db
      .child(`practices`)
      .orderByChild('id')
      .equalTo(pid)
      .on('value', snap => {
        if (!snap || !snap.exists()) {
          console.log('no practice found with id ' + pid);
          return;
        }
        let result = snap.val();
        let pracKeys = Object.keys(result);
        if (!pracKeys || pracKeys.length === 0) {
          window.location.href = '/404';
          return;
        }
        let pracKey = pracKeys[0];
        let practiceData = result[pracKey];
        console.log('Setting pracKey: ' + pracKey);
        this.setState({ data: practiceData, pracKey, pid });
      });

    return;
    // this.unsub = globals.db.child(`practices/${pracKey}`).on('value', snap => {
    //   console.log('got snap');
    //   if (!snap || !snap.exists()) {
    //     // message.error('Error fetching data for practice.');
    //     return;
    //   }
    //   console.log('got data');
    //   this.setState({ data: snap.val() });
    // });
  };

  componentWillUnmount = () => {
    if (this.unsub) this.unsub();
  };

  render() {
    const { data: propData } = this.props;
    const { data: stateData, pracKey } = this.state;

    const data = stateData || propData;

    // let hasProfiles = false;
    // for (let person of data.people) {
    //   if (person.image || person.bio) {
    //     hasProfiles = true;
    //   }
    // }
    console.log('rendering');

    // let content;
    if (this.state.loading || !data || !pracKey) {
      // console.log(this.state.loading);
      // console.log(JSON.stringify(data, null, 2));
      return (
        <div className="fullpage">
          <Spin />
        </div>
      );
    }

    return (
      <div className="PracticePage">
        <Helmet>
          <meta charSet="utf-8" />
          <title>{`${data.name} ${
            data.address.city && data.address.region
              ? `- ${data.address.city}, ${data.address.region} `
              : ''
          }| DPC Frontier Mapper`}</title>
          <meta name="description" content={data.description || ''} />
          <link rel="canonical" href="http://mysite.com/example" />

          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(structured.place(data), null, 2),
            }}
          />
          {structured.physicians(data).map(sd => {
            return (
              <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                  __html: JSON.stringify(sd, null, 2),
                }}
              />
            );
          })}
        </Helmet>
        <div className="body">
          {data.verified !== true && <UnverifiedSection />}
          {false ? <Header /> : <OldHeader />}
          {false && <BannerSection data={data} />}
          <TopInfoSection data={data} />
          <VideoSection data={data} />
          <PeopleSection data={data} />
          {false && <ContactSection data={data} />}
          {false && <PracticeInfoSection data={data} />}
          <LocationPhotosSection data={data} />
          <BenefitsSection data={data} />
          <PricingSection data={data} />
          <MapperSection data={data} />

          <SendMessageSection
            data={data}
            pracKey={this.state.pracKey || this.props.pracKey}
          />

          <EnrollmentSection data={data} />
          <DPCSection />
        </div>
        <Footer />
      </div>
    );
  }
}

export default PracticePage;
